import React, { useEffect, useMemo } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTeachersListRoutine } from 'modules/teachers/ducks/actions'
import { fetchSchoolSubjectsRoutine } from 'modules/settings/ducks/actions'
import { getActiveStudentsRoutine } from 'modules/students/ducks/actions'
import { selectActiveStudents } from 'modules/students/ducks/selectors'
import NewStudentsTable from 'modules/newStudents/components/NewStudentsTable'
import ExpandablePanel from 'components/ExpandablePanel'
import AddStudentForm from 'modules/students/components/AddStudentForm'

const createdAtToMs = raw => {
  if (raw == null || raw === '') return 0
  if (typeof raw === 'object' && typeof raw.seconds === 'number') {
    return raw.seconds * 1000
  }
  const n = Date.parse(String(raw))
  return Number.isNaN(n) ? 0 : n
}

const NewStudents = () => {
  const dispatch = useDispatch()
  const activeStudents = useSelector(selectActiveStudents)
  const newStudents = useMemo(() => {
    const list = activeStudents.filter(student => student.isNew === true)
    return [...list].sort(
      (a, b) => createdAtToMs(a.createdAt) - createdAtToMs(b.createdAt)
    )
  }, [activeStudents])

  useEffect(() => {
    dispatch(fetchTeachersListRoutine())
    dispatch(fetchSchoolSubjectsRoutine())
    dispatch(getActiveStudentsRoutine())
  }, [])

  return (
    <div>
      <HeaderRow>
        <PageHeader>Fiolety</PageHeader>
      </HeaderRow>
      <AddStudentForm
        callback={() => dispatch(getActiveStudentsRoutine())}
        skipAccount
        title='Nowy fiolet'
        showAvailability
        hideTeacherAssignment
        showPlannedSubjects
        isNewStudentsView
      />
      <ExpandablePanel startOpen title='Lista fioletów'>
        <NewStudentsTable
          studentsList={newStudents}
          actionCallback={() => dispatch(getActiveStudentsRoutine())}
        />
      </ExpandablePanel>
    </div>
  )
}

export default NewStudents

const HeaderRow = styled.div`
  margin-bottom: 20px;
`

const PageHeader = styled.div`
  font-size: 24px;
`
